module.exports = "<p>day-end works!</p>\n"